// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const duraludon_gmax: PokeData = {
  "id": 10225,
  "name": "duraludon-gmax",
  "height": 430,
  "weight": 10000,
  "base_experience": 187,
  "types": [
    PokeType.STEEL,
    PokeType.DRAGON
  ],
  "api_moves": [],
  "moves": [
    "great-roar",
    "scale-shot",
    "metal-burst",
    "smart-strike",
    "dragon-breath",
    "metal-sound",
    "meteor-mash",
    "dragon-pulse",
    "dragon-rush",
    "magnet-bomb",
    "steel-beam",
    "dragon-claw",
    "metal-claw"
  ],
  "evolution_chain": {
    "id": 465,
    "item": null,
    "species": [
      {
        "name": "duraludon",
        "order": 884,
        "types": [
          PokeType.STEEL,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "archaludon",
        "order": 1020,
        "types": [
          PokeType.STEEL,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 884,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 121,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
